import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Divider
} from '@material-ui/core';
import { formatValue } from 'utilities/format';

const ViewCrmCurrent = ({ classes, crmInfo }) => {
  return (
    <>
      <Typography className={classes.headerLabel} variant={'body1'}>General Info</Typography>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Created On: </Typography>
        <div></div>
        <Typography>{crmInfo.createdOn ? formatValue(crmInfo.createdOn, {type: 'date'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Updated On: </Typography>
        <div></div>
        <Typography>{crmInfo.updatedOn ? formatValue(crmInfo.updatedOn, {type: 'date'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Is In Special Flood Hazard Area: </Typography>
        <div></div>
        <Typography>{crmInfo.isInSpecialFloodHazardArea != null ? (crmInfo.isInSpecialFloodHazardArea ? 'True' : 'False') : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>CRM Stage Name: </Typography>
        <div></div>
        <Typography>{crmInfo.stageName ? crmInfo.stageName : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Sub-Stage: </Typography>
        <div></div>
        <Typography>{crmInfo.subStage ? crmInfo.subStage : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Opportunity Source: </Typography>
        <div></div>
        <Typography>{crmInfo.opportunitySource ? crmInfo.opportunitySource : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Contract Close Date: </Typography>
        <div></div>
        <Typography>{crmInfo.closeDate ? formatValue(crmInfo.closeDate, {type: 'date'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Lease End Date: </Typography>
        <div></div>
        <Typography>{crmInfo.leaseEndDate ? formatValue(crmInfo.leaseEndDate, {type: 'date'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Purchase Price: </Typography>
        <div></div>
        <Typography>{crmInfo.purchasePrice != null ? `$${crmInfo.purchasePrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <Divider className={classes.divider}/>
      <Typography className={classes.headerLabel} variant={'body1'}>Initial Negotiation</Typography>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Highest and Best: </Typography>
        <div></div>
        <Typography>{crmInfo.highestAndBest != null ? (crmInfo.highestAndBest ? 'True' : 'False') : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Asking Price: </Typography>
        <div></div>
        <Typography>{crmInfo.askingPrice ? `$${crmInfo.askingPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Counter Amount: </Typography>
        <div></div>
        <Typography>{crmInfo.counterAmount != null ? `$${crmInfo.counterAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Counter Notes: </Typography>
        <div></div>
        <Typography>{crmInfo.counterNotes ? crmInfo.counterNotes : ''}</Typography>
      </div>
      <Divider className={classes.divider}/>
      <Typography className={classes.headerLabel} variant={'body1'}>Due Diligence</Typography>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Under Contract Amount: </Typography>
        <div></div>
        <Typography>{crmInfo.underContractAmount != null ? `$${crmInfo.underContractAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Due Diligence End Date: </Typography>
        <div></div>
        <Typography>{crmInfo.dueDiligenceEndDate ? formatValue(crmInfo.dueDiligenceEndDate, {type: 'date'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Inspection Received Date: </Typography>
        <div></div>
        <Typography>{crmInfo.inspectionReceivedDate ? formatValue(crmInfo.inspectionReceivedDate, {type: 'date'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Proposed Repair Bid Amount: </Typography>
        <div></div>
        <Typography>{crmInfo.proposedRepairBidAmount != null ? `$${crmInfo.proposedRepairBidAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Recommended Concessions Date: </Typography>
        <div></div>
        <Typography>{crmInfo.amRecommendedConcessionsDate ? formatValue(crmInfo.amRecommendedConcessionsDate, {type: 'datetime'}) : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Asset Management User: </Typography>
        <div></div>
        <Typography>{crmInfo.amUser ? crmInfo.amUser : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Asset Management Notes: </Typography>
        <div></div>
        <Typography>{crmInfo.amUserNotes ? crmInfo.amUserNotes : ''}</Typography>
      </div>
      <Divider className={classes.divider}/>
      <Typography className={classes.headerLabel} variant={'body1'}>Concessions Negotiation</Typography>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Recommended Concessions: </Typography>
        <div></div>
        <Typography>{crmInfo.amRecommendedConcessions != null ? `$${crmInfo.amRecommendedConcessions.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Counter Concession Amount: </Typography>
        <div></div>
        <Typography>{crmInfo.counterConcessionAmount != null ? `$${crmInfo.counterConcessionAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Counter Concession Notes: </Typography>
        <div></div>
        <Typography>{crmInfo.counterConcessionNotes != null ? crmInfo.counterConcessionNotes : ''}</Typography>
      </div>
      <Divider className={classes.divider}/>
      <Typography className={classes.headerLabel} variant={'body1'}>Termination</Typography>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Termination Reason </Typography>
        <div></div>
        <Typography>{crmInfo.terminationReason ? crmInfo.terminationReason : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Termination Reason Detail: </Typography>
        <div></div>
        <Typography>{crmInfo.terminationReasonDetail ? crmInfo.terminationReasonDetail : ''}</Typography>
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.textLabel}>Untermination Reason: </Typography>
        <div></div>
        <Typography>{crmInfo.unterminationReason ? crmInfo.unterminationReason : ''}</Typography>
      </div>
    </>
  )
}

const styles = theme => ({
  dialog: {
    minWidth: '200px',
    minHeight: '150px'
  },
  textFieldRoot: {
    height: 70,
    marginBottom: 16,
    paddingRight: 8,
    flexBasis: '25%'
  },
  errorText: {
    lineHeight: 1
  },
  textWrapper: {
    paddingLeft: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'aliceblue'
    }
  },
  textLabel: {
    minWidth: '200px'
  },
  headerLabel: {
    fontWeight: 'bold'
  },
  divider: {
    marginTop: '4px',
    marginBottom: '4px'
  }
});

export default compose(
  withStyles(styles)
)(ViewCrmCurrent);